enum Selectors {
    mapContainerID = "mapContainer",
    mapWrapperID = "mapWrapper",
    sidebarContainerID = "sidebarContainer",
    sidebarContentContainerID = "sidebarContentContainer",
    searchContainerID = "searchContainer",
    searchWrapperID = "searchWrapper",
    searchInputID = "searchInput",
    listStoresContainerID = "listStoresContainer",
    toggleViewContainerID = "toggleViewContainer",
    toggleButtonID = "toggleButton",
    panMapControlID = "panMapControl"
}

export default Selectors;
